import { Link } from "react-router-dom";

const points = [
  {
    icon: "ri-hd-line",
    title: "高清片源整理",
    desc: "按清晰度整理影片资料，封面、简介、时长信息一次看全。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选找片",
    desc: "类型、地区、年份组合筛选，支持按更新、热度、评分排序。",
  },
  {
    icon: "ri-time-line",
    title: "更新节奏稳定",
    desc: "片单按周补充，首页「最新上映」与影库保持同步更新。",
  },
];

export default function IntroBand() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.2fr] lg:items-center">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.24em] text-primary-600">
              Why Here
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950">
              找一部片，不用翻三页
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
              蜜桃成熟时在线观看把影片资料、筛选项和播放演示放在同一条路径上。从首页到详情页最多两次点击，手机上同样顺手。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-800"
            >
              了解平台与内容说明
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {points.map((point, index) => (
              <div
                key={point.title}
                className="animate-fade-up rounded-lg border border-background-200 bg-background-50 p-5"
                style={{ animationDelay: `${index * 60}ms` }}
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${point.icon} text-lg w-[18px] h-[18px] flex items-center justify-center`} />
                </span>
                <h3 className="mt-4 text-sm font-medium text-foreground-950">{point.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}